import { Trash2, Plus } from 'lucide-react';
import { Button, Label, Textarea } from '@monksflow/monks-ui';
import { useFocusGroupFormStore } from '../../stores/focusGroupFormStore';
import { useTranslation } from 'react-i18next';

export const ReviewQuestionsStep = () => {
  const { t } = useTranslation('audiences');

  const questions = useFocusGroupFormStore((s) => s.generatedQuestions);
  const updateQuestion = useFocusGroupFormStore((s) => s.updateQuestion);
  const addQuestion = useFocusGroupFormStore((s) => s.addQuestion);
  const removeQuestion = useFocusGroupFormStore((s) => s.removeQuestion);

  return (
    <div className="flex flex-col gap-12 w-full max-w-[650px]">
      <div className="flex flex-col gap-4 text-center">
        <h2 className="text-xl font-medium text-foreground">
          {t('focusGroup.reviewQuestionsStep.reviewQuestions')}
        </h2>
        <p className="text-base text-muted-foreground">
          {t('focusGroup.reviewQuestionsStep.editAddOrRemoveQuestions')}
        </p>
      </div>

      <div className="flex flex-col gap-4">
        {questions.map((question, index) => {
          const fieldId = `focus-group-question-${question.id}`;
          return (
            <div key={question.id} className="flex flex-col gap-1">
              <Label htmlFor={fieldId} className="text-xs text-muted-foreground">
                {t('focusGroup.reviewQuestionsStep.questionNumber', { questionNumber: index + 1 })}
              </Label>
              <div className="flex items-start gap-2">
                <Textarea
                  id={fieldId}
                  rows={2}
                  value={question.text}
                  onChange={(e) => updateQuestion(index, e.target.value)}
                  className="flex-1 bg-muted"
                />
                {questions.length > 1 && (
                  <Button
                    variant="ghost"
                    size="mini"
                    className="mt-1 text-muted-foreground"
                    aria-label={t('focusGroup.reviewQuestionsStep.removeQuestion', {
                      question: index + 1,
                    })}
                    onClick={() => removeQuestion(index)}
                  >
                    <Trash2 size={16} />
                  </Button>
                )}
              </div>
            </div>
          );
        })}

        <button
          type="button"
          onClick={addQuestion}
          className="flex items-center gap-2 py-2 text-primary hover:opacity-80 text-sm font-medium"
        >
          <Plus size={16} />
          {t('focusGroup.reviewQuestionsStep.addQuestion')}
        </button>
      </div>
    </div>
  );
};
